import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

const apiUrl = resolveApiUrl("/product-comparison/removeAllProducts");

export function sendData() {
  return fetch(apiUrl, {
    method: "DELETE",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((res) => {
    console.log("res", res);
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    return res;
  });
}
